
document.addEventListener("DOMContentLoaded", () => {
  console.log("🟣 BUY BOX — DEBUG MODE ON (LOGS FULL)");

  /* ======================================================
     VARIANTES
  ====================================================== */
  const VARIANT_GRANDE  = 41198974533765;
  const VARIANT_PEQUENA = 41198974566533;

  console.log("🧩 VARIANTES CONFIG:", {
    grande: VARIANT_GRANDE,
    pequena: VARIANT_PEQUENA
  });

  /* ======================================================
     LEER CANTIDAD DESDE SHADOW HOST
  ====================================================== */
  function getShadowQty(id) {
    const host = document.getElementById(id);
    const input = host?.shadowRoot?.querySelector(".val");
    const qty = input ? parseInt(input.value) || 0 : 0;

    console.log(`🔎 [A1] Shadow Read (${id}) →`, {
      host: !!host,
      shadowRoot: !!host?.shadowRoot,
      rawValue: input?.value,
      qty
    });

    return qty;
  }

  /* ======================================================
     ABRIR DRAWER DE INSTANT
  ====================================================== */
  function openInstantDrawer() {
    const overlay = document.querySelector("[data-instant-overlay-pointer-events]");

    console.log("🟣 [C2] OPEN DRAWER →", {
      overlayFound: !!overlay,
      overlay
    });

    if (overlay) overlay.setAttribute("data-state", "open");
  }

  /* ======================================================
     REFRESH INSTANT
  ====================================================== */
  async function forceInstantRefresh() {
    console.log("🔄 [C1] FORCING INSTANT REFRESH…");

    const cart = await fetch("/cart.js").then(r => r.json());

    console.log("🟣 [C1.1] CART DE SHOPIFY →", cart);

    if (window?.Instant?.api?.updateCart) {
      console.log("🟣 [C1.2] USANDO Instant.api.updateCart(cart)");
      window.Instant.api.updateCart(cart);
    } else {
      console.log("🟣 [C1.2] USANDO fallback instant:cart:sync");
      document.dispatchEvent(
        new CustomEvent("instant:cart:sync", { detail: { cart } })
      );
    }

    // LOG: cómo queda Instant
    setTimeout(() => {
      console.log("🟣 [C1.3] Drawer Items Luego de REFRESH:");
      document.querySelectorAll("[data-instant-repeater-type='CART_ITEMS']").forEach((el, index) => {
        const title = el.querySelector("[data-instant-dynamic-content-source='TITLE']")?.textContent?.trim();
        const price = el.querySelector("[data-instant-dynamic-content-source='PRICE']")?.textContent?.trim();
        const qty = el.querySelector("[data-instant-dynamic-content-source='QUANTITY_SELECT']")?.value;

        console.log(`   📌 ITEM ${index+1}:`, { title, price, qty });
      });
    }, 400);
  }

  /* ======================================================
     BOTÓN CUSTOM ATC
  ====================================================== */
  const atc = document.querySelector(".btn-add-to-cart");

  console.log("🟣 INIT — ATC BUTTON →", {
    found: !!atc,
    node: atc
  });

  if (!atc) return;

  atc.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    console.log("🟣 [CLICK] Add To Cart PRESSED");

    /* ============================
       A — OBTENER SELECCIÓN
    ============================*/
    const qtyG = getShadowQty("qty-grande-shadow-host");
    const qtyP = getShadowQty("qty-pequena-shadow-host");

    const selected = [];
    if (qtyG > 0) selected.push({ variant: VARIANT_GRANDE, qty: qtyG });
    if (qtyP > 0) selected.push({ variant: VARIANT_PEQUENA, qty: qtyP });

    console.log("🟣 [A2] RESUMEN SELECCIÓN:", selected);

    if (selected.length === 0) {
      alert("Elegí al menos 1 item");
      return;
    }

    /* ============================
       B — UPDATE SHOPIFY CART
    ============================*/
    const updates = {
      [VARIANT_GRANDE]: qtyG,
      [VARIANT_PEQUENA]: qtyP
    };

    console.log("📡 [B1] Enviando /cart/update.js →", updates);

    let cartObj;

    try {
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });

      console.log("📡 [B1.1] Status:", updateResponse.status);

      await updateResponse.json();

      const cartRes = await fetch("/cart.js");
      cartObj = await cartRes.json();

      console.log("🧾 [B2] /cart.js RESULTADO REAL:", cartObj);

      console.table(cartObj.items.map(i => ({
        TITLE: i.title,
        VARIANT: i.variant_id,
        QTY: i.quantity
      })));
    } catch (err) {
      console.error("❌ Error durante update:", err);
      return;
    }

    /* ============================
       C — REFRESH + DRAWER
    ============================*/
    console.log("🟣 [C] REFRESH + DRAWER…");

    await forceInstantRefresh();
    overlay.setAttribute("data-state", "open");


    console.log("✨ FIN — ADD TO CART COMPLETO");
  });
});

